module.exports = __webpack_public_path__ + "img/65-l.b76aa7d0.png";